import React from 'react';
import { FileText } from 'lucide-react';
import Header from './components/Header9';
import Footer from './components/Footer9';

const TermsAndConditions = () => {
    const sections = [
        {
            title: '1. Acceptance of Terms',
            content: 'By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.'
        },
        {
            title: '2. Products and Pricing',
            content: 'All products listed on NAKSHA are subject to availability. We reserve the right to discontinue any product at any time. Prices for our products are subject to change without notice. All prices are displayed in Indian Rupees (INR) and include applicable taxes unless stated otherwise.'
        },
        {
            title: '3. Order Acceptance',
            content: 'Your receipt of an electronic or other form of order confirmation does not signify our acceptance of your order, nor does it constitute confirmation of our offer to sell. NAKSHA reserves the right at any time after receipt of your order to accept or decline your order for any reason.'
        },
        {
            title: '4. Payment Terms',
            content: 'We accept payment through credit cards, debit cards, UPI, net banking, and Cash on Delivery. All payment information is encrypted and processed securely. By providing payment information, you represent and warrant that you are authorized to use the designated payment method.'
        },
        {
            title: '5. Shipping and Delivery',
            content: 'NAKSHA ships to addresses within India and select international destinations. Delivery times are estimates and are not guaranteed. We are not responsible for delays caused by shipping carriers, customs, or other factors beyond our control.'
        },
        {
            title: '6. Returns and Refunds',
            content: 'Products may be returned within 7 days of delivery in their original, unworn condition with all tags attached. Customized items, intimate apparel, and items marked as final sale are not eligible for returns. Refunds will be processed to the original payment method within 7-10 business days.'
        },
        {
            title: '7. Intellectual Property',
            content: 'All content on this website, including but not limited to text, graphics, logos, images, and software, is the property of NAKSHA and is protected by Indian and international copyright laws. Unauthorized use or reproduction is strictly prohibited.'
        },
        {
            title: '8. User Accounts',
            content: 'When you create an account with us, you must provide accurate and complete information. You are responsible for maintaining the security of your account and password. NAKSHA will not be liable for any loss or damage from your failure to maintain account security.'
        },
        {
            title: '9. Limitation of Liability',
            content: 'NAKSHA shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our website or products. Our total liability to you shall not exceed the amount paid by you for the specific product giving rise to the claim.'
        },
        {
            title: '10. Governing Law',
            content: 'These terms shall be governed by and construed in accordance with the laws of India. Any disputes arising under or in connection with these terms shall be subject to the exclusive jurisdiction of the courts in Bangalore, Karnataka.'
        },
    ];

    return (
        <div className="w-full min-h-screen bg-white" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            <Header />
            <link href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

            <div className="pt-20 md:pt-24 pb-8 bg-[#F8FAFC] border-b border-[#E2E8F0]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center gap-2 mb-2">
                        <div className="w-8 h-0.5 bg-[#2563EB]" />
                        <p className="text-xs tracking-[0.3em] uppercase text-[#2563EB] font-medium">Legal</p>
                    </div>
                    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F172A]">Terms & Conditions</h1>
                    <p className="text-sm text-[#64748B] mt-3 font-light">Last updated: March 1, 2026</p>
                </div>
            </div>

            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
                <div className="space-y-8">
                    {sections.map((section, index) => (
                        <div key={index} className="border-l-2 border-[#E2E8F0] pl-6 hover:border-[#2563EB] transition-colors duration-300">
                            <h2 className="text-base sm:text-lg font-semibold text-[#0F172A] mb-3">{section.title}</h2>
                            <p className="text-sm text-[#64748B] leading-relaxed font-light">{section.content}</p>
                        </div>
                    ))}
                </div>

                <div className="mt-12 p-6 bg-[#F8FAFC] border border-[#E2E8F0] rounded-none">
                    <div className="flex items-start gap-3">
                        <FileText size={20} className="text-[#2563EB] flex-shrink-0 mt-0.5" />
                        <div>
                            <p className="text-sm font-medium text-[#0F172A] mb-1">Questions about our terms?</p>
                            <p className="text-sm text-[#64748B] font-light">
                                Contact us at{' '}
                                <a href="mailto:legal@naksha.in" className="text-[#2563EB] hover:text-[#1D4ED8]">legal@naksha.in</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default TermsAndConditions;
